import { render, staticRenderFns } from "./ReviewActionRow.vue?vue&type=template&id=09e5044a&scoped=true&"
import script from "./ReviewActionRow.vue?vue&type=script&lang=js&"
export * from "./ReviewActionRow.vue?vue&type=script&lang=js&"
import style0 from "./ReviewActionRow.vue?vue&type=style&index=0&id=09e5044a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e5044a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VIcon,VSwitch})
